<template>
  <div class="gerenciamento-log">
    <g-card class="card-gerenciamento-log" :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Log </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza" altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="limpaFiltro"
            />

            <g-button
            class="arquivo-button"
            tipo="amarelo"
            negritoTexto
            altura="35px"
            largura="150px"
            tamanhoTexto="14px"
            :sombreado="false"
            >
              GERAR ARQUIVO
            </g-button>

            <g-button
            class="buscar-button-header-filtro"
            largura="150px" icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="14px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="Grid"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="gerenciamento-log-conteudo espacamento-filtros">
          <div class="data-periodo-entre">
            <div class="data-periodo-titulo titulo-conteudo-filtros"> No período entre </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                class="data-periodo-inicio-input input-label"
                placeholderinput="Início"
                alturainput="42px"
                largurainput="100%"
                tamanhobotao="35px"
                alturabotao = "40px"
                v-model="objFiltro.Inicio"
                invertido
                retornaDateTime
                permiteDataPassadas
                dataPassadas
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                class="data-periodo-termino-input input-label"
                placeholderinput="Término"
                alturainput="42px"
                largurainput="100%"
                v-model="objFiltro.Fim"
                tamanhobotao="35px"
                alturabotao = "40px"
                invertido
                retornaDateTime
                permiteDataPassadas
                dataPassadas
                ></g-date-input>
              </div>
            </div>
          </div>
          
          <div class="filtro-nome-usuario">
            <div class="titulo-conteudo-filtros"> Usuário</div>
            <PDropDown
                  class="usuario-input input-label" 
                  v-model="objFiltro.UsuarioId"
                  :options="UsuarioArray"
                  optionLabel="nomeUsuario"
                  optionValue="id"
                  @filter="buscarUsuario($event.value)"
                  :filter="true"
                  placeholder="Selecione o Usuário"
                />
            <!-- <PDropDown class="usuario-input input-label" placeholder="Selecione" v-model="filtros[0].valor" @filter="buscarUsuario($event.value)"/> -->
          </div> 

          <div class="filtro-processo">
            <div class="titulo-conteudo-filtros"> Processo </div>
            <PDropDown
                  class="usuario-input input-label" 
                  v-model="objFiltro.DescricaoProcesso"
                  :options="ProcessoArray"
                  optionLabel="text"
                  optionValue="value"
                  :filter="true"
                  placeholder="Selecione o Processo"
                />
          </div> 

          <div class="filtro-tabela">
            <div class="titulo-conteudo-filtros"> Tabela </div>
            <PDropDown
                  class="usuario-input input-label" 
                  v-model="objFiltro.NomeTabela"
                  :options="TabelasArray"
                  optionLabel="nomeTabela"
                  optionValue="nomeTabela"
                  :filter="true"
                  placeholder="Selecione o Processo"
                />
          </div> 

          <div class="checkbox-filtros">
            <div class="parametros-titulo titulo-conteudo-filtros"> Outros Parâmetros </div>
            <div class="parametros-checkboxes">
                <div class="input-checkbox">
                  <PCheckBox v-model="objFiltro.Acesso" :binary="true"></PCheckBox>
                  <label class="label-checkbox"> Acesso </label>
                </div>
                <div class="input-checkbox">
                  <PCheckBox v-model="objFiltro.Consulta" :binary="true"></PCheckBox>
                  <label class="label-checkbox"> Consulta </label>
                </div>
                <div class="input-checkbox">
                  <PCheckBox v-model="objFiltro.Inclusao" :binary="true"></PCheckBox>
                  <label class="label-checkbox"> Inclusão </label>
                </div>
                <div class="input-checkbox">
                  <PCheckBox v-model="objFiltro.Alteracao" :binary="true"></PCheckBox>
                  <label class="label-checkbox"> Alteração </label>
                </div>
                <div class="input-checkbox">
                  <PCheckBox v-model="objFiltro.Exclusao" :binary="true"></PCheckBox>
                  <label class="label-checkbox"> Exclusão </label>
                </div>
                <div class="input-checkbox">
                  <PCheckBox v-model="objFiltro.Manutencao" :binary="true"></PCheckBox>
                  <label class="label-checkbox"> Manutenção </label>
                </div>
            </div>
          </div>
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        altura="35px"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="14px"
        gap="10px"
        :sombreado="false"
        @click="Grid"
        >
          BUSCAR
        </g-button>
      </div>
    </g-card>
    
    <g-card v-if="mensagemvazio" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>
    <!-- <g-card v-else-if="!mensagemvazio" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table
      Titulo="Log"
      altura="auto"
      :colunas="Colunas"
      :Paginacao="true"
      :valores="LogArray"
      :NumeroLinhas="30"
      :Filtros="Filtro"
      :numeroBotoesAcao="3"
      :FiltrosEspecificos="true"
      :rowEditor="true"
      :EscondeColunaBotao="true"
      ></g-data-table>
    </g-card> -->
    <DataGrid
      :busca="busca"
      :colunas="Colunas"
      :rota="rota"
      :valores="valores"
      :paginacao-remota="true"
      :parametros="parametros"
      placeholder-pesquisa="Buscar Log"
    />

  </div>
</template>

<script>
import GerenciamentoLog from "./GerenciamentoLog.js";
export default GerenciamentoLog;
</script>

<style scoped>
.titulo-filtros-cabecalho {
  font-size: 22px;
}

@media (min-width:310px) {
.arquivo-button {
  display: none;
}
}

@media (min-width:368px) {

}

@media (min-width:600px) {
.arquivo-button {
  display: block;
}

.parametros-checkboxes {
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
}
}

@media (min-width:700px) {
.gerenciamento-log-conteudo {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(3, auto);
  grid-column-gap: 20px;
}
.data-periodo-entre { grid-area: 1 / 1 / 2 / 2; }
.filtro-nome-usuario { grid-area: 1 / 2 / 2 / 3; }
.filtro-processo { grid-area: 2 / 1 / 3 / 2; }
.filtro-tabela { grid-area: 2 / 2 / 3 / 3; }
.checkbox-filtros { grid-area: 3 / 1 / 4 / 3; }
}

@media (min-width:801px) {

}

@media (min-width:1025px) { 
.gerenciamento-log-conteudo {
  grid-template-columns: repeat(3, minmax(4em, 1fr));
}
.data-periodo-entre { grid-area: 1 / 1 / 2 / 2; }
.filtro-nome-usuario { grid-area: 1 / 2 / 2 / 3; }
.filtro-processo { grid-area: 1 / 3 / 2 / 4; }
.filtro-tabela { grid-area: 2 / 1 / 3 / 2; }
.checkbox-filtros { grid-area: 3 / 1 / 4 / 4; }
}

@media (min-width:1281px) { 
    
}

@media (min-width:1400px) {
.gerenciamento-log-conteudo {
  display: grid;
  grid-template-columns: minmax(4em, 20em) repeat(3, minmax(4em, 24em));
  grid-template-rows: repeat(2, auto);
}
.data-periodo-entre { grid-area: 1 / 1 / 2 / 2; }
.filtro-nome-usuario { grid-area: 1 / 2 / 2 / 3; }
.filtro-processo { grid-area: 1 / 3 / 2 / 4; }
.filtro-tabela { grid-area: 1 / 4 / 2 / 5; }
.checkbox-filtros { grid-area: 2 / 1 / 3 / 5; }
}

</style>
